export default __webpack_public_path__ + "static/media/1be26b5c5e67b60dbd868f40a8f0fbd1.geojson";